import styled from "styled-components";

interface SidebarProps {
  children: React.ReactNode;
}

const StlyedDiv = styled.div``;

export const Sidebar = ({ children }: SidebarProps) => {
  return <StlyedDiv className="bg-white d-flex col-2">{children}</StlyedDiv>;
};
